import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContentMasteryTestErrorRateGauge from './ContentMasteryTestErrorRateGauge';
import { ContentMasteryErrorRateListService } from '../../services/ContentListService';
import ContentHistoryService from '../../services/ContentHistoryService';

class ContentMasteryTestErrorRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    ContentMasteryErrorRateListService.load();
  }
  render() {
    const data = ContentMasteryErrorRateListService.getChart();
    return (
      <ContentMasteryTestErrorRateGauge
        loading={
          ContentMasteryErrorRateListService.fetchCurrent.fetching ||
          ContentMasteryErrorRateListService.fetchPrevious.fetching
        }
        currentValue={toJS(data.current)}
        previousValue={toJS(data.previous)}
        formatter={ContentMasteryErrorRateListService.getFormattedValue}
        onClickHistory={() => ContentHistoryService.openDialog('MASTERY_TEST_EXECUTION_ERROR_RATE')}
      />
    );
  }
}

export default observer(ContentMasteryTestErrorRateGaugeContainer);
